import VueLoader from '../../default/vue-loader'

import H4HBreadcrumb from '../add_to_cart_forms/h4h_hotels/h4h_breadcrumb'
// import CheckoutBasic from './checkout_basic'
import ReworkedCheckout from './reworked_checkout_basic'
import CheckoutJqueryCarousel from './checkout_jquery_carousel'

import { store } from'../../default/store'
import init from '../add_to_cart_forms/h4h_rooms/gmaps_initialization'

document.addEventListener('turbo:load', () => {
  VueLoader.loadVueComponent(H4HBreadcrumb, document.getElementById('h4h-breadcrumb'), store)
})

export default   {
  loadWithBasicAddOn() {
    return VueLoader.loadVueComponent(ReworkedCheckout, document.getElementById('checkoutVue'), store)
  },

  loadWithJqueryAddOn() {
    return CheckoutJqueryCarousel.loadWithAddOnAndCarousel(this.loadWithBasicAddOn())
  },

  async loadWithAddOn() {
    await init()
    if(window.checkout_version === 'table_display')
      return this.loadWithBasicAddOn()
    else
      return this.loadWithJqueryAddOn()
  }
}
